module.exports = __webpack_public_path__ + "static/media/39.f28804e5.jpg";